/**
 *
 * PopupMenu
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MenuItem } from 'react-bootstrap';
import { Popup, withLeaflet } from 'react-leaflet';
import { FormattedMessage } from 'react-intl';

const Wrapper = styled(Popup)`
  .leaflet-popup-content-wrapper {
    border-radius: 4px;
  }
  .leaflet-popup-content {
    margin: 0 20px 0 0;
  }
  ul.dropdown-menu {
    position: relative;
    display: block;
    border: none;
    float: none;
    box-shadow: none;
    padding: 0;
    margin: 0;
    li a {
      padding: 3px 10px;
    }
  }
`;

class PopupMenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(item) {
    const { onClick, leaflet, position } = this.props;
    return ev => {
      ev.preventDefault();
      const clickPosition =
        position || leaflet.popupContainer.getPopup().getLatLng();
      onClick(item)(clickPosition);
      leaflet.map.closePopup();
    };
  }

  render() {
    const { items, messages, disabled, onOpen, onClose, position } = this.props;
    return (
      <Wrapper onOpen={onOpen} onClose={onClose} position={position}>
        <ul className="dropdown-menu open">
          {items.map(item => (
            <MenuItem
              key={item}
              eventKey={item}
              href={`#${item}`}
              onClick={this.handleClick(item)}
              disabled={disabled.includes(item)}
            >
              <FormattedMessage {...messages[item]} />
            </MenuItem>
          ))}
        </ul>
      </Wrapper>
    );
  }
}

PopupMenu.propTypes = {
  position: PropTypes.object,
  items: PropTypes.array.isRequired,
  messages: PropTypes.object.isRequired,
  disabled: PropTypes.array,
  onClick: PropTypes.func.isRequired,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  leaflet: PropTypes.object.isRequired,
};

PopupMenu.defaultProps = {
  disabled: [],
};

export default withLeaflet(PopupMenu);
